// extracted by mini-css-extract-plugin
export default {"l_DetailIconBtn_innerContainer":"DetailIconBtn_l_DetailIconBtn_innerContainer__RxeYR"};